import { MoveAttachmentToInlineText } from './moveAttachmentToInlineContextMenuItemBuilder.locstring.json';
import loc from 'owa-localize';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { AttachmentFullViewState, AttachmentMenuAction } from 'owa-attachment-full-data';
import { PreviewContext } from 'owa-attachment-select-actions';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';
import convertAttachmentToInline from '../../services/convertAttachmentToInline';

export default function moveAttachmentToInlineContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType?: string,
    targetWindow?: Window,
    sxsId?: string,
    isConsumer?: boolean,
    attachmentOriginalUrl?: string,
    permissionLevel?: AttachmentPermissionLevel,
    previewContext?: PreviewContext,
    parentItemId?: ItemId,
    replaceAttachmentHandler?: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void,
    AttachLongPathName?: string,
    container?: HTMLElement,
    moveAttachmentToInlineHandler?: (
        attachment: AttachmentFullViewState,
        contentId: string
    ) => Promise<void>
): IContextualMenuItem {
    if (
        !isMenuActionSupported(AttachmentMenuAction.MoveAttachmentToInline, attachment) ||
        !attachment.strategy.isMoveAttachmentToInlineSupported
    ) {
        return null;
    }

    return {
        name: getMoveAttachmentToInlineContextMenuName(),
        key: 'MoveAttachmentToInline',
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? { iconName: ControlIcons.Photo2 }
                : undefined,
        onClick: () => {
            moveAttachmentToInlineInternal(attachment, parentItemId, moveAttachmentToInlineHandler);
        },
    };
}

function moveAttachmentToInlineInternal(
    attachment: AttachmentFullViewState,
    parentItemId: ItemId,
    moveAttachmentToInlineHandler: (
        attachment: AttachmentFullViewState,
        contentId: string
    ) => Promise<void>
) {
    // Place ContentId on image.
    convertAttachmentToInline(attachment, parentItemId).then(contentId => {
        moveAttachmentToInlineHandler(attachment, contentId);
    });
}

function getMoveAttachmentToInlineContextMenuName(): string {
    return loc(MoveAttachmentToInlineText);
}
